import { wrapperBuilder } from './build';
import { MODES } from './interfaces';

const staticsRegister = wrapperBuilder.getStaticsGeneratorsRegisterInstance();

staticsRegister.addStaticProp('MODES', MODES);
